import classNames from 'classnames';
import * as React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { Close } from '../../Icons';
import styles from './modal.module.css';

interface ModalProps {
    callBack?: () => void;
    header?: string;
    hideHeader?: boolean;
    style?: Record<string, string>;
    contentClassName?: string;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
    callBack,
    children,
    header = '',
    hideHeader = false,
    style = {},
    contentClassName,
}) => (
    <div className={styles.Modal}>
        <OutsideClickHandler
            onOutsideClick={() => {
                if (callBack) {
                    callBack();
                }
            }}
        >
            <div className={classNames(styles.ModalContent, contentClassName)} style={style}>
                {!hideHeader && (
                    <div className={styles.ModalHeader}>
                        <h2 data-qa={`modal-header-${header}`}>{header}</h2>
                        {callBack && (
                            <button
                                className={styles.ModalCloseButton}
                                type="button"
                                onClick={callBack}
                                data-qa="modal-callback-button"
                                aria-label="Close"
                            >
                                <div className={styles.ModalHeaderIcon} data-qa="modal-header-icon">
                                    <Close aspect="1.5rem" />
                                </div>
                            </button>
                        )}
                    </div>
                )}
                {children}
            </div>
        </OutsideClickHandler>
    </div>
);

export default Modal;
